module.exports = __webpack_public_path__ + "static/media/logo-dark.d9f05854.webp";